<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import LightAdvancedView from 'src/components/Sidepanel/DeviceViews/Light/LightAdvancedView.svelte';
	import TemplatesDeviceDrawerV2 from '../TemplatesDeviceDrawerV2.svelte';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { isNativeXt1LightComponent } from 'src/helpers/light_priority_layout';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: statuses = status_configurator(status, device);
	$: useLightPriority = isNativeXt1LightComponent(device);
</script>

{#if useLightPriority}
	<LightAdvancedView {device} />
{:else}
	<DeviceViewStateWrapper {device}>
		<div slot="content" class="flex-full-height">
			<TemplatesDeviceDrawerV2 {device} {statuses} />
		</div>
	</DeviceViewStateWrapper>
{/if}
